/**
 * 
 * @copyright     (c) 2025 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/_components/Tabs/index.js
 * Created:       Tue Jan 07 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Apr 22 2025
 */

import React, { useState, useCallback } from 'react';

export default function Tabs({
  items,
  tabIndex,
  setTabIndex
}) {

  return (
    <>
      <ul className="gc__tab_navigation">
        {items.map((tab, index) =>
          <li
            key={`gcTab${index}`}
            className={`gc__tab_navigation_item ${(index === tabIndex) ? "gc__active" : ""}`}
          >
            <a
              onClick={(event) => {
                event.preventDefault();
                setTabIndex(index);
              }}
              className="gc__tab_navigation_link"
              aria-current="page"
              href={undefined}
            >
              {tab.title}
            </a>
          </li>
        )}
      </ul>
      <div>
        <div
          className="gc__tab_content_wrapper"
          style={{
            transform: `translateX(-${100 * tabIndex}%)`,
          }}
        >
          {items.map((item, index) =>
            <div
              key={`gcTabContent${index}`}
              className={(index === tabIndex )? "gc__tab_content gc__tab_content_active" : "gc__tab_content"}
            >
              {item.content}
            </div>
          )}
        </div>
      </div>
    </>
  );
};
